import GoogleLogin from 'react-google-login';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';

import { useAuth } from '../../context/Auth';
import { useModalContext } from '../../context/Modal';
import { useSignInContext } from './SignInContext';

import { LOGIN_WITH_GOOGLE } from '../../http/apollo-queries';

import { Button } from '../../components/UI';
import { Loading } from '../../components/UI';
import { useEffect } from 'react';
import { SignupStatusEnum } from '../../constants/enums';
import { useNavigate } from 'react-router-dom';
import { logger } from '../../helpers/logger';

const SignInWithGoogle = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user, signIn } = useAuth();
  const { state, dispatch } = useSignInContext();
  const { dispatch: setModal, closeModal } = useModalContext();

  const [loginWithGoogle] = useMutation(LOGIN_WITH_GOOGLE);

  useEffect(() => {
    if (state.logged && user) {
      if (SignupStatusEnum[user.signupStatus]) {
        navigate(SignupStatusEnum[user.signupStatus]);
      } else {
        // navigate('/actual'); 07-06-'22
        navigate('/strategies');
      }
    }
  }, [user]);
  const handleSuccess = (res: any) => {
    setModal({
      isFullScreenElement: true,
      className: 'bg-grey-90 bg-opacity-10',
      element: (
        <Loading
          className="w-32 h-16 m-auto text-primary"
          size="large"
          status
        />
      ),
    });

    const googleUser = res?.profileObj;
    const googleId = res?.googleId;
    const token = res?.tokenId;

    //console.log('GoogleAuth:token', token);
    logger.log('GoogleAuth:googleId', googleId);

    loginWithGoogle({
      variables: {
        email: googleUser.email,
        googleId,
        token,
      },
    })
      .then((res: any) => {
        const { otpPassword } = res.data?.loginWithGoogle;
        return signIn(googleUser.email, otpPassword);
      })
      .then((res: any) => {
        dispatch({ type: 'SET_LOGGED', payload: true });
      })
      .catch((err) => {
        logger.error('signInWithGoogle - error', err);

        if (err.message === 'USER_ALREADY_REGISTERED') {
          toast.error(
            'User already registered, please use another email address!'
          );
        } else {
          toast.error(t('signUp.form.signupWithGoogleError.' + err.message));
        }
      })
      .finally(closeModal);
  };

  const handleFailure = async (error: any) => {
    console.log(error);
    //toast.error(t('signUp.form.signupWithGoogleError.' + error.message));
  };

  return (
    <GoogleLogin
      clientId={process.env.REACT_APP_GOOGLE_ID!}
      render={(renderProps) => (
        <Button
          type="button"
          onClick={renderProps.onClick}
          buttonClass="border border-grey-30 w-full p-2 font-semibold dark:text-white text-black mt-4"
        >
          {t('signIn.form.loginWithGoogle')}
          <img alt="google" src="/google.svg" className="ml-auto" />
        </Button>
      )}
      onSuccess={handleSuccess}
      onFailure={handleFailure}
      isSignedIn={false}
      cookiePolicy={'single_host_origin'}
    />
  );
};

export default SignInWithGoogle;
